import { IonAvatar, IonCard, IonCardContent, IonCol, IonIcon, IonImg, IonRow, IonText } from "@ionic/react"
import { calendarClearOutline, chatboxOutline } from 'ionicons/icons';
import Image from "../image/Image";

import './BlogItem.css';

interface Props {
    id: number,
    image: string,
    title: string,
    description: string,
    comments: string,
    date: string,
    link: string
}

const BlogItem: React.FC<Props> = (props) => {
    return <IonCard routerLink={props.link} button className="blog-item">
        <IonCardContent>
            <IonRow>
                <IonCol size="2">
                    <Image src={props.image} />
                </IonCol>
                <IonCol size="10" style={{ paddingRight: "20px" }}>
                    <IonText className="title">{props.title}</IonText>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol size="12">
                    <IonText class="description">{props.description}</IonText>
                </IonCol>
            </IonRow>
        </IonCardContent>

        <IonRow className="footer">
            <IonCol size="6">
                <IonText className="comments"><IonIcon src={chatboxOutline} />{props.comments}</IonText>
            </IonCol>
            <IonCol size="6">
                <IonText className="date"><IonIcon src={calendarClearOutline} />{props.date}</IonText>
            </IonCol>
        </IonRow>
    </IonCard>
}

export default BlogItem